module.exports = __webpack_public_path__ + "static/media/GillSans.bbf1fe92.ttf";